import { IPromise } from 'angular';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { APCRGenericSlot } from '../../builders/ap_generic_slot_builder';

class CommentDialogController {
  private genericSlot: APCRGenericSlot & {
    plannedCourse: NonNullable<APCRGenericSlot['plannedCourse']>;
  };
  private type: 'flag' | 'unFlag';
  private message: string;
  private messageMaxLength = 280;
  private isSaveUpdatesDisabled: boolean = false;
  private title: string;
  private dialogTitle: string;
  private dialogBodyText: string;
  private isOpened: boolean = true;
  constructor(
    private ngAPNotificationDelegate: INotificationDelegate,
    private $state: any,
    private $element: ng.IAugmentedJQuery,
    private phxFocusDelegate: any,
    private phxAxReturnFocusFactory: any,
    private createCourseFlagCommand: ICommand,
    private updateCourseFlagCommand: ICommand,
    private removeCourseFlagCommand: ICommand
  ) {}

  initialize() {
    this.title = `${this.genericSlot.plannedCourse._course.cd} ${this.genericSlot.plannedCourse._course.title}`;
    this.message = _4.get(this.genericSlot, 'flagComment.comment', '');
    this.disableSaveUpdates();
  }

  disableSaveUpdates() {
    this.isSaveUpdatesDisabled =
      this.message.length === 0 || this.message === _4.get(this.genericSlot, 'flagComment.comment');
  }
  $onChanges() {
    this.initialize();
  }

  $onInit() {
    this.initialize();
  }

  openedChanged() {
    this.$state.__goToPrevious__();
    this.phxFocusDelegate.focus(this.phxAxReturnFocusFactory.getFocusId());
  }

  closeDialog() {
    this.isOpened = false;
  }

  removeFlag() {
    this.removeCourseFlagCommand(_4.get(this.genericSlot, 'flagComment.id'))
      .then(() => {
        this.closeDialog();
        this.ngAPNotificationDelegate.success(`Successfully removed flag from ${this.title}`);
      })
      .catch(() => {
        this.ngAPNotificationDelegate.error(`Unable to remove flag from ${this.title}`);
      });
  }

  createOrUpdateFlag() {
    const isCourseFlagged = this.genericSlot.isCourseFlagged;

    let commandForFlagging: IPromise<any>;

    if (isCourseFlagged) {
      // see the params diff
      commandForFlagging = this.updateCourseFlagCommand(_4.get(this.genericSlot, 'flagComment.id'), this.message);
    } else {
      commandForFlagging = this.createCourseFlagCommand(this.genericSlot.plannedCourse._course.id, this.message);
    }
    commandForFlagging
      .then(() => {
        this.closeDialog();
        let successMessage: string;
        if (isCourseFlagged) {
          successMessage = `Successfully updated the ${this.title}'s flag`;
        } else {
          successMessage = `Successfully flagged the course ${this.title}`;
        }
        this.ngAPNotificationDelegate.success(successMessage);
      })
      .catch(() => {
        let failureMessage: string;
        if (isCourseFlagged) {
          failureMessage = `Unable to update ${this.title}'s flag`;
        } else {
          failureMessage = `failed to flag the course ${this.title}`;
        }
        this.ngAPNotificationDelegate.error(failureMessage);
      });
  }
}

angular.module('capability-ng-academic-planner').component('courseFlagDialog', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/course_flag_dialog/course_flag_dialog.html',
  bindings: {
    genericSlot: '<'
  },
  controller: CommentDialogController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_flag_dialog/course_flag_dialog.ts